import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppService } from "@App/app.service";
import { IConfigService } from "@Config";
import { NotesDTO } from "@DTOs";
import { UWResponse } from "@Models";
import { BaseService } from "@Services";
import { ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SidebarService extends BaseService {
    constructor(
        public configService: IConfigService,
        public httpClient: HttpClient,
        public appService: AppService
    ) {
        super(appService, configService, httpClient);
    }
    
    private notesLoaded = false;
    private caseIdForLoadedNotes = '';

    private notesSub = new ReplaySubject<NotesDTO[]>(1);
    public notes$ = this.notesSub.asObservable();

    private notesAreLoaded = (caseId: string) => caseId == this.caseIdForLoadedNotes && this.notesLoaded;
    

    public reloadNotes(clientId: string, caseId: string, hideWaiting = false) {
        const url = `${this.appService.getAPIBaseURL()}Notes/${caseId}?isSidebar=true`;
        super.getData<UWResponse<NotesDTO[]>>(url, clientId, hideWaiting).subscribe({
            next: notes => {
                this.notesSub.next(notes.data ?? []);
                this.notesLoaded = true;
                this.caseIdForLoadedNotes = caseId;
            },
            error: () => {
                console.error(`Error loading notes for case ${caseId} in SidebarService`);
            }
        });
        return this.notes$;
    }

    public loadNotes(clientId: string, caseId: string) {
        if (this.notesAreLoaded(caseId)) return this.notes$;

        const response = this.reloadNotes(clientId, caseId);
        return response;
    }
}